import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./motion";
import { MONTH_SLUGS } from "../data/months";

// The landing's routing grid — the 8 pages visitors actually want (per pageview data).
const CARDS = [
  { to: "/planner", label: "The free itinerary planner", sub: "Build your days in two minutes", img: "/planner/115c33e22770.webp", hot: true },
  { to: "/copenhagen-itinerary", label: "3-day itinerary", sub: "A ready-made 1–3 day route", img: "/planner/rundetaarn.webp" },
  { to: "/transport", label: "Transport", sub: "Metro, bikes & harbour buses", img: "https://customer-assets-cm19k8pv.emergentagent.net/job_explore-copenhagen/artifacts/rppjvlko_2026-09-24%2011_56_58.503%2B0200.webp" },
  { to: "/areas", label: "The areas", sub: "Pick your neighbourhoods", img: "/streets/grabrodretorv.webp" },
  { to: `/copenhagen-in/${MONTH_SLUGS[new Date().getMonth()]}`, label: "Month by month", sub: "What to expect, January to December", img: "https://customer-assets-cm19k8pv.emergentagent.net/job_explore-copenhagen/artifacts/i5tzj4n6_2026-09-24%2011_54_48.360%2B0200.webp" },
  { to: "/stay", label: "Where to stay", sub: "Hostels to five-star, by area", img: "https://images.unsplash.com/photo-1764756719784-7e46c361e0ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" },
  { to: "/bakeries", label: "Bakeries", sub: "Which queue is worth it", img: "/planner/d42dfee2df14.webp" },
  { to: "/smorrebrod", label: "Smørrebrød", sub: "The open-sandwich guide", img: "https://customer-assets-cm19k8pv.emergentagent.net/job_explore-copenhagen/artifacts/xs7lrasl_20260823_083049%280%29.webp" },
  { to: "/photo-worthy-streets", label: "Photo-worthy streets", sub: "The lanes your camera wants", img: "/streets/nyboder.webp" },
  { to: "/trips", label: "Day trips", sub: "Castles, Vikings & Sweden", img: "https://thumb.wikimedia.org/wikipedia/commons/thumb/3/32/Frederiksborg_Castle%2C_Hiller%C3%B8d.jpg/1280px-Frederiksborg_Castle%2C_Hiller%C3%B8d.jpg" },
];

export const StartHere = () => (
  <section data-testid="start-here" className="py-12 md:py-20 bg-[#F9F8F6] border-b border-zinc-200">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <Reveal>
        <p className="font-body font-800 text-xs tracking-[0.3em] eyebrow text-[#DF3226] mb-3">JUMP STRAIGHT IN</p>
        <h2 className="font-display font-900 tracking-tight text-3xl md:text-5xl mb-8">
          Where do you want <span className="font-editorial italic font-600">to start?</span>
        </h2>
      </Reveal>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
        {CARDS.map((c, i) => (
          <Reveal key={c.to} delay={Math.min(i * 0.04, 0.2)} y={24}>
            <Link
              to={c.to}
              data-testid={`start-here-${c.to.slice(1)}`}
              className={`group block h-full rounded-xl border overflow-hidden shadow-brut hover:-translate-y-1 hover:shadow-brut-lg transition-all ${
                c.hot ? "bg-[#DF3226] text-white border-black" : "bg-white text-black border-zinc-200"
              }`}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={c.img}
                  alt={`${c.label} — Copenhagen guide`}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-3.5 md:p-5">
                <p className="font-display font-900 tracking-tight text-base md:text-xl leading-tight flex items-start justify-between gap-2">
                  {c.label}
                  <ArrowUpRight
                    size={18}
                    className={`shrink-0 mt-0.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5 ${
                      c.hot ? "text-[#DF3226]" : "text-[#DF3226]"
                    }`}
                  />
                </p>
                <p className={`font-body text-xs md:text-sm mt-1 ${c.hot ? "text-white/80" : "text-black/60"}`}>{c.sub}</p>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
